import React from 'react';
import PropTypes from 'prop-types';
import './modal.scss';
import Button from '../ui/Button';

const Modal = ({
	isOpen,
	onClose,
	title,
	children,
	className,
	cancelButton,
	actionButton,
	handleSave,
	handleClose,
	headerClassName,
	bodyClassName,
	titleClassName,
	badge = null,
	subtitle = '',
	secondaryText = '',
	dataTestId = '',
}) => {
	if (!isOpen) return null;

	return (
		<div
			className={`modal-backdrop`}
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			<div
				className={`modal-content ${className}`}
				data-testid={dataTestId || undefined}
				onClick={(e) => e.stopPropagation()}
			>
				<div className={title ? `modal-header ${headerClassName}` : ''}>
					<div>
						<div className="d-flex align-items-center gap-4">
							{title && (
								<div
									className={`${titleClassName}`}
									style={{ fontSize: '16px', fontWeight: '600' }}
								>
									{title}
								</div>
							)}
							{badge !== null && (
								<span
									className={`px-3 py-1 fs-6 text-primary bg-primary-subtle border border-primary rounded-pill`}
								>
									{badge}
								</span>
							)}
						</div>
						{subtitle && (
							<div
								className={`fw-semibold fs-5`}
								style={{ color: '#718096' }}
							>
								{subtitle}
							</div>
						)}
					</div>

					<div className="d-flex">
						{actionButton && (
							<Button
								type="button"
								className="btn btn-lg btn-primary px-4 add-pro"
								button="Save"
								onClick={(e) => {
									e.stopPropagation();
									handleSave();
								}}
							/>
						)}
						{cancelButton && (
							<div className="d-flex align-items-center gap-4">
								<div className="lead text-secondary">{secondaryText}</div>
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									onClick={() => {
										handleClose && handleClose();
										onClose();
									}}
									dataTestId={dataTestId ? `${dataTestId}-close-button` : ''}
								/>
							</div>
						)}
					</div>
				</div>
				<div className={`modal-body ${bodyClassName}`}>{children}</div>
			</div>
		</div>
	);
};

Modal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string,
	children: PropTypes.node,
};

Modal.defaultProps = {
	title: '',
	children: null,
};

export default Modal;
